import React, { Fragment } from 'react';
import styles from './FieldItemSubList.module.scss';
import { FieldItemListType } from '../FieldItemList';
import { SectionFieldItem } from '../../SectionField/SectionFieldItem/SectionFieldItem';
import { Divider } from '../../../../../Divider/Divider';
import { FieldValueType } from '../../../../../../Models';

export interface FieldItemSubListProps {
  title: string;
  fields: FieldItemListType[];
}

export const FieldItemSubList = ({
  title,
  fields
}: FieldItemSubListProps): React.ReactElement<FieldItemSubListProps> => {
  return (
    <div className={styles.fieldListSubItem}>
      <h4 className={styles.title}>{title}</h4>
      <div className={styles.container}>
        {fields &&
          fields.map((field: FieldItemListType, index: number) => {
            if (!Array.isArray(field) && field.value) {
              return (
                <Fragment
                  key={`${field.label ? field.label : 'field'}-${index}`}
                >
                  {index > 0 && <Divider className={styles.divider} />}
                  <SectionFieldItem
                    label={field.label}
                    value={field.value as FieldValueType}
                    type={field.type}
                  />
                </Fragment>
              );
            } else if (Array.isArray(field)) {
              return (
                <Fragment
                  key={`${field[0]?.label ? field[0]?.label : 'sublist'}-${index}`}
                >
                  {index > 0 && <Divider className={styles.divider} />}
                  {field.map(
                    (subField: FieldItemListType, subIndex: number) => {
                      return (
                        <SectionFieldItem
                          key={`${subField.label ? subField.label : 'subfield'}-${subIndex}`}
                          label={subField.label}
                          value={subField.value as FieldValueType}
                          type={subField.type}
                        />
                      );
                    }
                  )}
                </Fragment>
              );
            }
            return null;
          })}
      </div>
    </div>
  );
};
